import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  width: 100%;

  .loading-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    margin: 0 auto;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    margin: 0 auto;
  }
`;

export const TopContentWrapSC = styled.div`
  padding-bottom: 24px;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  @media (max-width: ${BP_TABLET_MAX}px) {
    margin-bottom: 16px;
    padding-bottom: 0px;
  }
`;

export const MidContentWrapSC = styled.div`
  padding-bottom: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const BottomContentWrapSC = styled.div`
  padding-bottom: 16px;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`;

export const LeftContentWrapSC = styled.div`
  flex: 2;
  margin-right: 24px;
  @media (max-width: ${BP_TABLET_MAX}px) {
    flex: none;
    width: 100%;
    margin-right: 0px;
  }
`;

export const RightContentWrapSC = styled.div`
  flex: 1;

  @media (max-width: ${BP_TABLET_MAX}px) {
    flex: none;
    width: 100%;
    max-width: 560px;
    margin: 0 auto;
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    margin: 0 auto;
  }
`;
